import styled from 'styled-components';

export const CustomScrollbar = styled.div`
  overflow: auto;

  /* 定义滚动条宽高及背景 */
  &::-webkit-scrollbar {
    width: 5px;
    height: 10px;
  }

  /* 定义滚动条轨道 */
  &::-webkit-scrollbar-track {
    border-radius: 10px;
  }

  /* 定义滚动条拖拽块 */
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.2);
  }

  /* 当鼠标悬停在滚动条拖拽块上时 */
  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.4);
  }
`;
